import { render, staticRenderFns } from "./material_manage.vue?vue&type=template&id=bdf5e2ca&scoped=true&"
import script from "./material_manage.vue?vue&type=script&lang=js&"
export * from "./material_manage.vue?vue&type=script&lang=js&"
import style0 from "./material_manage.vue?vue&type=style&index=0&id=bdf5e2ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf5e2ca",
  null
  
)

export default component.exports